import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { TooltipCC } from 'components/common';
import { IconDeleteUser, IconEditUser } from 'components/common/IconCommon';
import { DialogConfirmChangeVersion, useDialog } from 'components/DialogV3';
import NotFoundData from 'components/NotFound';
import { PaginationButtons, TableHeaderCC, TypographyCellCC } from 'components/Table';
import { headCellsManageVersion } from 'components/Table/Functions';
import { TIME_FORMAT } from 'constants/common';
import { useResponsiveCC } from 'hooks';
import moment from 'moment';
import { getHeightStatic } from 'pages/manager-meeting/Func';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SwitchIOS from 'shared/components/base/SwitchIOS';
import { transHeadCells } from 'utils/functions';
import { getIndexCellTable } from 'utils/helpers';
import { deleteVersion, releaseVersion } from '../store/managerVerionSlice';
import { PADDING_CONTENT_PAGE } from 'constants/ui.contants';

const TableManageVersion = ({
    tableData = [],
    page,
    size,
    setPage,
    sizeRow
}) => {
    const { t } = useTranslation();
    const { getWidthRatio, isLargePC } = useResponsiveCC();
    const navigate = useNavigate()
    const {openDialog} = useDialog()

    const handleDeleteVersion = (version) => {
        try {
            openDialog(DialogConfirmChangeVersion, {
                titleKey: 'title.confirmDeleteVersion',
                contentKey: 'content.confirmDeleteVersionActive',
                versionName: version?.name,
                version: version?.version_code,
                actionKey: 'actions.delete',
                onAction: () => deleteVersion({id: version?.id})
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleUpdateStatusVersion = (version) => {
        try {
            openDialog(DialogConfirmChangeVersion, {
                titleKey: 'title.confirmChangeVersion',
                contentKey: version?.status ? 'content.confirmStopVersionActive' : 'content.confirmActiveVersion',
                versionName: version?.name,
                version: version?.version_code,
                actionKey: 'actions.save',
                onAction: () => releaseVersion({id: version?.id})
            })
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', padding: PADDING_CONTENT_PAGE, mt: '20px' }}>
            <TableContainer
                component={Paper}
                sx={{
                    overflowX: 'initial',
                    overflowY: 'auto',
                    boxShadow: 'none',
                    height: isLargePC || window.innerHeight > 800 || !tableData?.total ? 'auto' : getHeightStatic(2.5),
                }}
            >
                <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={sizeRow}>
                    <TableHeaderCC
                        headCellTable={transHeadCells(headCellsManageVersion, t)}
                        rowId='id'
                        rows={tableData?.data}
                    />
                    <TableBody>
                        {tableData.data ? (
                            tableData.data.map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;

                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.id}
                                        sx={{ cursor: 'auto' }}
                                    >
                                        <TableCell padding="checkbox" align="center">
                                            {getIndexCellTable(page, size, index)}
                                        </TableCell>
                                        <TableCell component="th" id={labelId} scope="row" sx={{ width: getWidthRatio(280) }}>
                                            <TooltipCC title={row.name} placement="bottom-start">
                                                <TypographyCellCC sx={{ width: getWidthRatio(280) }}>
                                                    {row.name ?? '---'}
                                                </TypographyCellCC>
                                            </TooltipCC>
                                        </TableCell>
                                        <TableCell sx={{ width: getWidthRatio(100) }} align="left">
                                            <TooltipCC title={row.version_code} placement="bottom-start" >
                                                <TypographyCellCC sx={{ width: getWidthRatio(100) }}>
                                                    {row.version_code}
                                                </TypographyCellCC>
                                            </TooltipCC>
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.release_timestamp ? moment.unix(row.release_timestamp).format(TIME_FORMAT.FULL_24h) : '---'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.description ?? '---'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.released_by_username ?? '---'}
                                        </TableCell>
                                        {/* <TableCell align="left" sx={{ width: 180 }}>{moment(row.created_date * 1000).format(TIME_FORMAT.FULL_24h)}</TableCell> */}
                                        <TableCell align="left" sx={{ fontWeight: 500, color: row.status ? '#0053AD' : '#CB002B', width: 180 }}>
                                            <SwitchIOS
                                                // disabled={!canEdit}
                                                id={`switch-status-${row.id}`}
                                                checked={row.status === 1}
                                                onChange={(e) =>
                                                    handleUpdateStatusVersion(row)
                                                }
                                            />
                                        </TableCell>
                                        <TableCell align="center" sx={{ p: 0, width: 100 }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                {
                                                    true && (
                                                        <TooltipCC title={t('actions.edit')}>
                                                            <IconButton
                                                                size={sizeRow}
                                                                onClick={() => navigate(`update/${row?.id}`)}
                                                                id={`btn-edit-version-${row?.id}`}
                                                            >
                                                                <IconEditUser />
                                                            </IconButton>
                                                        </TooltipCC>
                                                    )
                                                }
                                                {
                                                    true && (
                                                        <TooltipCC title={t('actions.delete')} placement="bottom-start">
                                                            <IconButton
                                                                size={sizeRow}
                                                                onClick={() => handleDeleteVersion(row)}
                                                                id={`btn-del-version-${row?.id}`}
                                                            >
                                                                <IconDeleteUser />
                                                            </IconButton>
                                                        </TooltipCC>
                                                    )
                                                }
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <NotFoundData />
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {tableData.total ? (
                <PaginationButtons
                    page={page}
                    handleChangePage={(e, page) => setPage(page - 1)}
                    limit={size}
                    total={tableData.total}
                />
            ) : (
                <></>
            )}
            {tableData?.total === 0 && (
                <NotFoundData />
            )}
        </Box>
    )
}

export default TableManageVersion